// src/pages/EssensChatScreen.js
import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

function EssensChatScreen() {
  const { user } = useAuth();
  const [message, setMessage] = useState('');
  const [chatLog, setChatLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatLog]);

  const handleSend = async () => {
    if (!message.trim()) return;
    const userMessage = { role: 'user', text: message };
    setChatLog((prev) => [...prev, userMessage]);
    setMessage('');
    setLoading(true);

    try {
      const docRef = doc(db, 'kodeessens', user.uid);
      const docSnap = await getDoc(docRef);
      const kodeData = docSnap.exists() ? docSnap.data() : {};

      const prompt = `Kode-Essens:\nKodeord: ${kodeData?.kodeord || 'ukjent'}\nKjennetegn: ${kodeData?.kjennetegn || 'ukjent'}\nEssens-setning: ${kodeData?.essensSetning || 'ukjent'}\nTilkallingsformel: ${kodeData?.tilkallingsformel || 'ukjent'}\n\nBrukermelding: ${message}`;

      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer 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`
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            { role: 'system', content: 'Du er en bevisst veileder basert på brukerens Kode-Essens.' },
            { role: 'user', content: prompt }
          ]
        })
      });

      const data = await response.json();
      const gptSvar = data.choices?.[0]?.message?.content || '⚠️ Ingen svar mottatt fra GPT.';
      setChatLog((prev) => [...prev, { role: 'assistant', text: gptSvar }]);
    } catch (error) {
      setChatLog((prev) => [...prev, { role: 'assistant', text: '❌ Feil ved kontakt med GPT API.' }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-screen bg-[#343541] text-white">
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        {chatLog.map((msg, idx) => (
          <div
            key={idx}
            className={`max-w-2xl mx-auto p-4 rounded-xl text-sm whitespace-pre-wrap shadow-md ${
              msg.role === 'user' ? 'bg-[#2A2B32] self-end text-right' : 'bg-[#444654] self-start text-left'
            }`}
          >
            <div className="text-xs mb-1 text-gray-400 font-semibold">
              {msg.role === 'user' ? 'Du' : 'EssensGPT'}
            </div>
            {msg.text}
          </div>
        ))}
        {loading && (
          <div className="text-center text-gray-400">GPT svarer ...</div>
        )}
        <div ref={chatEndRef} />
      </div>

      <div className="bg-[#40414F] p-4 border-t border-gray-700 fixed bottom-0 w-full">
        <div className="flex items-center max-w-4xl mx-auto gap-2">
          <input
            type="text"
            placeholder="Skriv en melding..."
            className="flex-1 p-3 rounded-md bg-[#2A2B32] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
          />
          <button
            onClick={handleSend}
            className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

export default EssensChatScreen;
